import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CardContent, Grid, Typography } from "@mui/material";
import { Tabs } from "antd";
import { Card } from "react-bootstrap";
import { selectCurrentUser } from "features/auth/authSlice";
import { useGetDashboardProfileQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import { store } from "app/store";
import { API_URL } from "app/config";
import FarmerList from "features/onboarding/users/farmer/FarmerList";
import EmployeesList from "features/userManagement/EmployeesList";
import EmandiReports from "features/E-Mandi/EmandiReport/emandiReport";
import { Mandi } from "features/E-Mandi/EmandiReport/Mandi";
import RiskManagementGtPoint from "features/dashboard/RiskManagement/RiskManangementGtPoint";
import HclDashNav from "components/HclDashNav";
import HclMapFullData from "./HclMapFullData";

const HclDashboard = () => {
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles || [];

  const navigate = useNavigate();
  const [apiData, setApiData] = useState([]);
  const [geoJson, setGeoJson] = useState([]);
  const [mandiCard, setMandiCard] = useState({
    total: "",
    sum: "",
    totalQuantity: 0,
  });

  const { data: userProfile } = useGetDashboardProfileQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );

  const setGeojsonInParent = (data) => setGeoJson(data);

  useEffect(() => {
    fetchMandiData();
  }, []);

  const fetchMandiData = async () => {
    try {
      const state = store.getState();
      const response = await fetch(
        `${API_URL}/api/v1/onboarding/farmer-aggrigation`,
        {
          headers: { authorization: `Bearer ${state.auth.accessToken}` },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      const filteredData = data?.data?.filter(
        (item) => item.current_status === "Procurement Done"
      );

      const totalQuantity = filteredData?.reduce((sum, item) => {
        let quantity = Number(item.quantity || 0);
        if (item.unit_of_quantity === "Quintals") quantity *= 100;
        return sum + quantity;
      }, 0);

      setMandiCard({
        total: data?.data || [],
        totalQuantity,
      });
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    if (userProfile?.data) setApiData(userProfile.data);
  }, [userProfile]);

  const formatProcurement = () => {
    const quantity = mandiCard?.totalQuantity || 0;
    if (quantity < 1000) return `${Math.round(quantity).toLocaleString()} Kg`;
    if (quantity < 10000)
      return `${Math.round(quantity / 100).toLocaleString()} Quintal`;
    return `${Math.round(quantity / 1000).toLocaleString()} MT`;
  };

  const cards = useMemo(() => {
    const baseCards = [
      {
        title: "Farmers",
        icon: "https://onboarding.agrani.io/assets/farmers-CTZXnfqs.png",
        total: apiData?.total_customers,
        action: () => navigate("/onboarding/farmers"),
      },
      {
        title: "Land Holding",
        icon: "https://onboarding.agrani.io/assets/acerage-CbrTaoRH.png",
        total: apiData?.land_holding
          ? `${parseInt(apiData.land_holding)} Acres`
          : "0 Acres",
      },
      
      {
        title: "Crops",
        icon: "https://onboarding.agrani.io/assets/wheat-Cd8AZQ9X.png",
        total: apiData?.crops_dealing?.length,
      },
      {
        title: "Procurement",
        icon: "https://cdn-icons-png.flaticon.com/512/4866/4866817.png",
        total: mandiCard?.total?.length,
        totalProcure: formatProcurement(),
      },
      {
        title: "Employees",
        icon: "https://onboarding.agrani.io/assets/staff-BoxwbA8A.png",
        total: apiData?.total_employees,
        action: () =>
          navigate(`/employees/${apiData?.organization_details?.id}`),
      },
    ];

    if (RoleAcessParams.includes("CBBO")) {
      baseCards.unshift({
        title: "FPO",
        icon: "https://onboarding.agrani.io/assets/wheat-Cd8AZQ9X.png",
        total: apiData?.total_fpos,
        action: () => navigate("/onboarding/fpo"),
      });
    }

    return baseCards;
  }, [apiData, mandiCard, RoleAcessParams]);

  return (
    <div style={{ background: "#fbfbfb" }}>
      <HclDashNav />
      <div
        className="container-fluid"
        style={{ paddingLeft: "6rem", paddingRight: "6rem" }}
      >
        <Grid container spacing={2} alignItems="center" className="mt-2">
          {cards.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
              <Card
                style={{
                  height: "120px",
                  cursor: item.action ? "pointer" : "default",
                }}
                onClick={item.action}
              >
                <CardContent sx={{ textAlign: "center", p: 3 }}>
                  <Typography
                    variant="h5"
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {item.title}
                    <img src={item.icon} style={{ width: "1.8rem" }} />
                  </Typography>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <h5 className="text-black">Total</h5>
                    <p
                      className="fs-5"
                      style={{ fontSize: "40px", color: "#006EB7" }}
                    >
                      {item.total}
                    </p>
                  </div>
               

                  {/* {item.title === "Procurement" && (
                    <div className="d-flex justify-content-between align-items-center mt-1">
                      <Typography variant="body1" color="text.secondary">
                        <i>Total Produce</i>
                      </Typography>
                      <Typography variant="h5" sx={{ color: "#C76E00" }}>
                        {item.totalProcure || 0}
                      </Typography>
                    </div>
                  )} */}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <div className="mt-4">
          <Tabs
            items={[
              {
                key: "Farmers",
                label: "Farmers",
                children: (
                  <div className="mt-2">
                    <FarmerList
                      showMap={false}
                      setGeojsonInParent={setGeojsonInParent}
                      isHCL
                    />
                  </div>
                ),
              },
              {
                key: "Cluster Map",
                label: "Cluster Map",
                children: (
                  <Card className="" style={{ height: "90svh" }}>
               
                    <HclMapFullData
                    RoleAcessParams={RoleAcessParams}
                    />
                  </Card>
                 
                ),
              },
              {
                key: "E-Mandi",
                label: "E-Mandi",
                children: (
                  <Mandi
                    isHCL
                    // isHCL={true}
                  />
                ),
              },
              {
                key: "Live Mandi Prices",
                label: "Live Mandi Prices",
                children: (
                  <div style={{ marginTop: "-1%" }}>
                    <EmandiReports isHCL />
                  </div>
                ),
              },
              {
                key: "GT Point",
                label: "GT Point",
                children: <RiskManagementGtPoint isHCL />,
              },
              {
                key: "Employees",
                label: "Employees",
                children: <EmployeesList />,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default HclDashboard;
